import React, { useState } from 'react';
import {
  Input, Card, Table, Button, Breadcrumb, Col, Row, Space, Spin,
} from 'antd';
import { useTranslation } from 'react-i18next';
import {
  PlusOutlined, StepForwardOutlined, UserOutlined, FilterOutlined, FilterFilled, SearchOutlined,
} from '@ant-design/icons';
import { ResponsiveContainer } from 'recharts';
import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout';
import CenteredContent from '@common/components/ui/CenteredContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrochip } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import useHomeBusinessType from './useHomeBusinessType';
import styles from './HomeBusinessType.module.less';

const { Search } = Input;

const style = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 25,
  marginTop: 25,
  cursor: 'pointer',
};

function HomeBusinessType() {

  const { t } = useTranslation();
  const {
    loading, businessType, goToDeviceBusinessType, onSearch, changeSort, sorter, createBusinessType,
    loadingBusiness, isCreate
  } = useHomeBusinessType();
 

  return (
    <MainLayout applyWidthLimit>
      <ResponsiveContainer>
        <div>
          {loading ? (
            <>
              <CenteredContent>
                <Spin tip={t('views.device_graphics.loading_data_graphs')} />
              </CenteredContent>
            </>
          ) : (
            <>
              <Row>
                <Col span={24} style={{ padding: '.95rem' }}>
                  <Card style={{ width: '100%' }}>
                    <Row>
                      <Col xs={24} sm={24} md={20} lg={20} xl={20}>
                        <Row className="miga_title">{t('common.welcome')}</Row>
                        <Row style={{ fontSize: '14px', color: '#8c8c8c' }}>
                          <Breadcrumb className={styles.date_wrapper}>
                            <Breadcrumb.Item className={styles.breadcrumb}>
                              <Link to="/">{t('menu_items.main.home')}</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item className={styles.breadcrumb}>
                              {t('views.create_business_type.business')}
                            </Breadcrumb.Item>
                          </Breadcrumb>
                        </Row>
                      </Col>

                      {
                        isCreate &&
                          <Col xs={24} sm={24} md={4} lg={4} xl={4} className="text-right">
                            <Button type="primary" style={{ float: 'right', padding: '.5rem 1rem 1.8rem', width: '100%' }} onClick={createBusinessType}>
                              <PlusOutlined />
                              {` ${t('common.btn_create_bussiness')}`}
                            </Button>
                          </Col>
                      } 
                    </Row>
                    <Row gutter={8}>
                      <Col xs={24} sm={24} md={21} lg={22} xl={22} style={{ display: 'flex', marginTop: '1rem' }}>
                        <Input
                          size="large"
                          placeholder={t('common.search_business')}
                          prefix={<SearchOutlined />}
                          style={{}}
                          onChange={onSearch}
                        />
                      </Col>
                      <Col xs={12} sm={12} md={3} lg={2} xl={2} style={{ display: 'flex', justifyContent: 'end', marginTop: '1rem' }}>
                        <Button className={sorter ? 'active-filter' : ''} style={{ padding: '.5rem 1rem 1.8rem' }} onClick={changeSort}>AZ</Button>
                      </Col>
                      {/* <Col xs={12} sm={12} md={3} lg={2} xl={1} style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                        <Button style={{ padding: '.5rem 1rem 1.8rem' }}>
                          <FilterFilled />
                        </Button>
                      </Col> */}
                    </Row>
                  </Card>
                </Col>
              </Row>
              <Row>
                {
                  loadingBusiness ? (
                    <Row style={{
                      width: '100%', magin: 'auto', display: 'flex', justifyContent: 'center', justifyItems: 'center',
                    }}
                    >
                      <Col style={{ justifyContent: 'center', marginTop: '5%' }}>
                        <Spin tip={t('views.device_graphics.loading_data_graphs')} />
                      </Col>
                    </Row>
                  ) : (
                    businessType.map((item, i) => (
                      <Col key={i} xs={24} sm={16} md={12} lg={8} xl={6}>
                        <div style={style} onClick={() => goToDeviceBusinessType(item)}>
                          <Card style={{ width: '90%' }}>
                            <div style={{
                              fontSize: 20, fontWeight: 'bold', marginBottom: 10, color: '#000000',
                            }}
                            >
                              {	item.logo_full_url && item.logo_full_url !== ''
                                ? (
                                  <img
                                    src={item.logo_full_url}
                                    alt={item.title}
                                    className="image-logo-busines"
                                  />
                                )
                                : (
                                  <FontAwesomeIcon
                                    icon={faMicrochip}
                                    style={{ fontSize: 24, color: '#787878', marginRight: '1rem' }}
                                  />
                                )}
                              <span>{item.title}</span>
                            </div>
                            <div>
                              <p style={{ minHeight: '44px', color: '#8c8c8c' }}>{item.description}</p>
                              <div style={{ borderRadius: 10 }}>
                                <Row>
                                  <Col span={24}>
                                    <div style={{ marginBottom: 5 }}>
                                      <div style={{ fontSize: 18, fontWeight: 'bold' }}>
                                        {t('common.devices')}
                                      </div>
                                    </div>
                                    <ul>
                                      <li style={{ marginBottom: 5, color: '#8c8c8c' }}>
                                        {t('common.totals')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          {item.total_general}
                                        </span>
                                      </li>
                                      <li style={{ marginBottom: 5, color: '#8c8c8c' }}>
                                        {t('common.connecteds')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          {item.total_conecy}
                                        </span>
                                      </li>
                                    </ul>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col span={24}>
                                    <div style={{ marginBottom: 5 }}>
                                      <div style={{ fontSize: 18, fontWeight: 'bold' }}>
                                        {t('common.clients')}
                                      </div>
                                    </div>
                                    <ul>
                                      <li style={{ marginBottom: 5, color: '#8c8c8c' }}>
                                        {t('common.totals')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          {item.total_general_clients}
                                        </span>
                                      </li> 
                                    </ul>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Card>
                        </div>
                      </Col>
                    ))
                  )
                }
              </Row>
            </>
          )}
        </div>
      </ResponsiveContainer>
    </MainLayout>
  );

}

export default withAuth(HomeBusinessType);
